import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";
import { ImageLazyLoad } from "../ImageLazyLoad";

const FullWidthImageWrapper = styled.div`
  max-width: 100vw;
  max-height: 100vh;
  overflow: hidden;
  position: relative;
  left: 50%;
  margin-left: -50vw;
  padding: ${props => props.padding};
  img {
    width: 100%;
    height: 100%;
    /* max-height: 100vh; */
    object-fit: cover;
  }
`;

const FullWidthImage = props => (
  <FullWidthImageWrapper padding={props.padding}>
    <ImageLazyLoad src={props.src} />
  </FullWidthImageWrapper>
);

FullWidthImage.propTypes = {
  src: PropTypes.string,
  padding: PropTypes.string
};

FullWidthImage.defaultProps = {
  src: "",
  padding: "0px"
};

export { FullWidthImage };
